import { render, staticRenderFns } from "./SimpleModeLander.vue?vue&type=template&id=7c80b106&scoped=true&"
import script from "./SimpleModeLander.vue?vue&type=script&lang=ts&"
export * from "./SimpleModeLander.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleModeLander.vue?vue&type=style&index=0&id=7c80b106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80b106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c80b106')) {
      api.createRecord('7c80b106', component.options)
    } else {
      api.reload('7c80b106', component.options)
    }
    module.hot.accept("./SimpleModeLander.vue?vue&type=template&id=7c80b106&scoped=true&", function () {
      api.rerender('7c80b106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/simpleMode/SimpleModeLander.vue"
export default component.exports